import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import './i18n'; // Importer et initialiser i18n avant l'App

//Service Worker registration
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered:', registration.scope);
      })
      .catch(error => {
        console.error('Service Worker registration failed:', error);
      });
  });
}


// Réduire les logs superflus en développement qui peuvent causer des problèmes de performance
if (import.meta.env.DEV) {
  // Enregistrer la version originale de console.log et console.warn
  const originalConsoleLog = console.log;
  const originalConsoleWarn = console.warn;
  const originalConsoleError = console.error;

  // Nombre maximum de fois où le même message peut être affiché dans un intervalle de temps
  const maxRepeatedLogs = 3;
  const clearLogInterval = 5000;
  const logCounts = new Map();

  // Si le debug est activé, on ne touche pas à la console
  if (!import.meta.env.VITE_DEBUG) {
    // Limiter les logs répétitifs
    console.log = (...args) => {
      const key = JSON.stringify(args);
      const count = (logCounts.get(key) || 0) + 1;
      logCounts.set(key, count);
      
      if (count <= maxRepeatedLogs) {
        originalConsoleLog(...args);
      } else if (count === maxRepeatedLogs + 1) {
        originalConsoleLog(`Message répété trop souvent, suppression des occurrences suivantes: `, ...args);
      }
    };

    // Filtrer certains avertissements de React et du HMR
    console.warn = (...args) => {
      const message = args[0]?.toString() || '';
      
      // Ignorer certains avertissements spécifiques qui peuvent causer des problèmes
      if (
        message.includes('[HMR]') ||
        message.includes('[vite]') ||
        message.includes('React does not recognize the') ||
        message.includes('Warning: React state update on an unmounted component')
      ) {
        return;
      }
      
      originalConsoleWarn(...args);
    };

    // Nettoyer périodiquement les compteurs de logs
    setInterval(() => {
      logCounts.clear();
    }, clearLogInterval);
  }

  // Gérer spécifiquement les erreurs de WebSocket qui peuvent causer des rafraîchissements
  window.addEventListener('error', (event) => {
    if (event.message && event.message.includes('WebSocket')) {
      // Empêcher certaines erreurs WebSocket de déclencher un rafraîchissement
      event.preventDefault();
      // Néanmoins, log l'erreur pour le debug
      originalConsoleError('WebSocket error intercepted:', event.message);
    }
  });

  // Afficher un message au démarrage
  originalConsoleLog('🚀 Application démarrée en mode développement avec optimisations anti-refresh');
}

// Si l'application est en mode development et a des problèmes de refresh
if (import.meta.env.DEV && import.meta.env.VITE_DISABLE_AUTO_REFRESH) {
  // Désactiver automatiquement le rechargement complet de la page via HMR
  if (import.meta.hot) {
    console.log('⚙️ HMR optimisé pour éviter les rafraîchissements automatiques');
    
    // Configurer le comportement personnalisé pour HMR
    import.meta.hot.on('vite:beforeUpdate', (payload) => {
      // On peut ajouter une logique pour contrôler quand autoriser les mises à jour
      console.log(`🔄 Mise à jour HMR détectée pour: ${payload.updates.map(u => u.path).join(', ')}`);
    });
  }
}

// Log de débogage pour le développement
if (process.env.NODE_ENV === 'development') {
  console.log('🌐 Initialisation des traductions');
}

// Rendu de l'application
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
